import WebRepository from '../web/WebRepository'
import Api from 'clients/web/Api'
import PatientVitalsMetadata from 'model/PatientVitalsMetadata'

export class PatientVitalsMetadataRepository extends WebRepository<PatientVitalsMetadata> {
  constructor() {
    super(new Api('vitals_metadata'))
  }

  async search(userId: any): Promise<PatientVitalsMetadata[]> {
    return super.search({
      selector: {
        patientId: {
          $eq: userId,
        },
      },
    })
  }
}

export default new PatientVitalsMetadataRepository()
